<template>
  <div :class="{'ca-filtro--enMenu': en_menu}" class="ca-filtro">
    <v-text-field
      :clearable="clearable"
      :disabled="disabled"
      :placeholder="placeholder"
      :prepend-inner-icon="icon"
      :value="filtro"
      @input="filtrarItems($event)"
      class="ca-filtro-textfield"
      clear-icon="cancel"
      solo
      v-if="!en_menu"
      @click.stop
      :autofocus="autofocus"
    >
    </v-text-field>
    <v-text-field
      :clearable="clearable"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="filtro"
      @click.stop
      @input="filtrarItems($event)"
      clear-icon="cancel"
      ref="input"
      v-else
      :autofocus="autofocus">
    </v-text-field>
  </div>
</template>

<script>
/**
   * Componente de Filtrado de Arreglos de Objetos
   * Filtra de un arreglo de items aquellos que tenga en alguna de las claves definidas en keys
   * el filtro escrito.
   *
   * Se puede recuperar el estado original de los items pasando el prop reset a true
   */
export default {
  props: {
    // Core
    items: {type: Array, default: () => []},
    items_sin_filtrar: {type: Array, default: () => []},
    keys: {type: Array, default: () => []},
    reset: {type: Boolean, default: false},
    filtro: {type: String, default: null},

    // Estado
    en_uso: {type: Boolean, default: false},

    // Modificadores
    en_menu: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    clearable: {type: Boolean, default: true},
    // Caracteres a omitir en la busqueda
    // Formato regex, por ejemplo: simbolos_omitidos=" º°.\-/" excluirá los simbolos: " ", "º", "°", ".", "-", "/"
    simbolos_omitidos: {type: String, default: null},
    case_sensitive: {type: Boolean, default: false},
    placeholder: {type: String, default: null},
    icon: {type: String, default: 'filter_list'},
    // Si activado, se hace autofocus automáticamente al mostrar el filtro
    autofocus: {type: Boolean, default: false}
  },
  data() {
    return {
      filtro_copy: null,
    };
  },
  mounted() {
    if (this.en_menu) {
      // La primera vez que se abre desde menú se autoenfoca el filtro, el offset de 100ms es por la transición del menú.
      setTimeout(() => {
        this.$refs.input.focus();
      }, 100);
    }
  },
  computed: {
    filtroEnUso() {
      return !!this.filtro_copy && this.filtro_copy.length > 0;
    }
  },
  watch: {
    filtro_copy(val) {
      if (this.filtro !== val) {
        this.$emit('update:filtro', val);
      }
    },
    items_sin_filtrar: {
      immediate: true, // Seteo inicial
      handler: function (val) {
        this.filtro_copy = '';
        this.$emit('update:items', [...val]);
      }
    },
    reset(val) {
      if (val) {
        this.filtro_copy = '';
        this.$emit('update:items', this.items_sin_filtrar);
        this.$emit('update:reset', false);
      }
    },
    filtroEnUso(val) {
      this.$emit('update:en_uso', val);
    }
  },
  methods: {
    /**
       * Limpia el string pasado como parámetro, necesario antes de realizar la comparación para saber si un item
       *  respeta el filtro o no.
       *
       * Invocado tanto con el filtro como con los valores de los items.
       *
       * @param cadena
       *
       * @returns string
       */
    obtenerStringEfectivo(cadena) {
      if (!cadena && cadena !== 0) {
        return '';
      }
      let texto = cadena.toString();
      if (!this.case_sensitive) {
        texto = texto.toLowerCase();
      }
      if (this.simbolos_omitidos) {
        texto = texto.replace(new RegExp('[' + this.simbolos_omitidos + ']', 'g'), '');
      }
      return texto;
    },
    /**
       * Función de filtrado, actualiza el prop items solo si hubo cambios.
       *
       * @param filtro
       */
    filtrarItems(filtro) {
      this.filtro_copy = filtro;
      let items_filtrados = this.items_sin_filtrar.filter(item => {
        for (let key of this.keys) {
          let atributo = key.split('.').reduce((acumulado, actual) => {
            return acumulado ? acumulado[actual] : false;
          }, item);

          if (atributo && this.obtenerStringEfectivo(atributo).includes(this.obtenerStringEfectivo(filtro)))
            return true;
        }
        return false;
      });

      this.$emit('update:items', [...items_filtrados]);
    }
  }
};
</script>

<style lang="scss">
 // @import "variables";

  .ca-filtro {
    .ca-filtro-textfield {
      margin: 10px 4px;

      .v-input__control {
        height: 34px;
        justify-content: center;
        min-height: 34px;
      }

      .v-input__slot {
        background-color: color(gris-claro) !important;
        color: color(gris);
        font-size: 14px;
        min-height: 34px;
        margin: 0;
      }

      .v-input__icon--clear .v-icon {
        font-size: 18px;

        &:hover {
          color: color(rojo) !important;
        }
      }
    }
    &.ca-filtro--enMenu {
      margin: 0;
      padding: 0 15px;
    }
  }
</style>